export default __webpack_public_path__ + "static/media/cat5-3-updated.0e687855.png";